module.exports = __webpack_public_path__ + "img/pad-fill-profile-chart-slide1.fce66a4e.gif";